import { Box, Typography } from '@mui/material';
import { SkinnedBalanceModal } from '../../../../config/skinRegistry/components';
import { getWalletModalProps } from '../../../../config/walletModal';
import { useModal } from '../../../../hooks/useDialog';
import useLocalization from '../../../../hooks/useLocalization';
import { useMarketplaceConfig } from '../../../../queries/marketplace';
import { FormattedBalance } from '../../../atoms/FormattedBalance';
import NeobetRaisedActionButton from './NeobetRaisedActionButton';
import { styles } from './Header.styles';

const BalanceDepositControl = () => {
  const { openModal, closeModal } = useModal();
  const { isPay2LocalPayment } = useMarketplaceConfig();
  const { t } = useLocalization();

  const handleOpenModal = () => {
    openModal(
      <SkinnedBalanceModal handleClose={closeModal} showBalanceContact={isPay2LocalPayment} />,
      getWalletModalProps({ backgroundColor: 'neutral.700' })
    );
  };

  return (
    <Box sx={styles.balanceGroup} data-testid='neobet-balance-group'>
      <Box sx={styles.balanceValue} data-testid='neobet-balance-pill'>
        <Typography
          variant='body2'
          sx={{
            fontWeight: 700,
          }}
        >
          <FormattedBalance balanceType='main' />
        </Typography>
      </Box>
      <NeobetRaisedActionButton
        aria-label={t('deposit')}
        label='+'
        data-testid='neobet-deposit-plus'
        visualVariant='icon'
        onClick={handleOpenModal}
      />
    </Box>
  );
};

export default BalanceDepositControl;
